import useMountEffect from "@p-ban/common/src/hooks/useMountEffect"

import userApi from "../api/user/userApi"

export const setUserId = (userId: string | null) => {
  window.dataLayer = window.dataLayer ?? ([] as unknown[])
  window.dataLayer.push({ user_id: userId })
}

/**
 * GTMにカスタムイベントを送信する
 * @param event イベント名
 * @param userId ユーザID。未設定時は送信しない
 */
export const sendCustomEvent = (event: string, userId?: string | null) => {
  window.dataLayer = window.dataLayer ?? ([] as unknown[])
  window.dataLayer.push({ event, ...(userId && { user_id: userId }) })
}

export const useGoogleAnalytics = () => {
  useMountEffect(() => {
    userApi
      .accountInfo()
      .catch(() => null)
      .then((info) => {
        setUserId(info?.id ?? null)
      })
  })
}
